import { styled } from '@material-ui/core';

const PageWrapper = styled('div')({
  padding: '25px 40px',
});

export default PageWrapper;
